import React, { useState, useEffect, Suspense } from 'react';
import { useParams, Link } from "react-router-dom";
import lodash from 'lodash';
import { message } from 'antd';
import dayjs from 'dayjs';
import { PhotoSwiper } from '../../../../../components';
import { productInfo, disneyPriceList, systemTime } from '../../../../../api';
import { calculateTargetDateWithHolidays } from '../../../../../utils/common';
import './style.scss';



const ProductDetail = () => {
  const no = useParams().no;
  const [baseInfo, setBaseInfo] = useState(null);
  const [minPrices, setMinPrices] = useState(null);

  useEffect(() => {
    fetchPriceList();
    // const min_day_ticket = {displayPrice: '475.00'};
    // const min_early_bird_ticket = {displayPrice: '425.00'}
    // setMinPrices({
    //   min_day_ticket: Number(min_day_ticket.displayPrice),
    //   min_early_bird_ticket:  Number(min_early_bird_ticket.displayPrice)
    // })
    // 获取产品详情
    productInfo(no).then((res) => {
      setBaseInfo(res.data);
    }).catch((err) => { });
  }, [no]);

  async function fetchPriceList() {
    try {
      const current = await systemTime();
      const currentDate = current.data.date;

      const res = await disneyPriceList();

      //当前日期 和 预订日期 之间必须包含 2个工作日，计算最早可预订时间
      const startDate = calculateTargetDateWithHolidays(currentDate);
      let day_ticket = Object.entries(res.data.day_ticket.date_data).map(([date, value]) => ({ ...value, date }));
      let index1 = day_ticket.findIndex(v => v.date === startDate);
      day_ticket = day_ticket.slice(index1);

      // 早鸟根据当前日期 在往后推10天
      const birdCurrentDate = dayjs(currentDate).add(10, 'day').format('YYYY-MM-DD');
      const birdStartDate = calculateTargetDateWithHolidays(birdCurrentDate);
      let early_bird_ticket = Object.entries(res.data.early_bird_ticket.date_data).map(([date, value]) => ({ ...value, date }));
      let index2 = early_bird_ticket.findIndex(v => v.date === birdStartDate);
      early_bird_ticket = early_bird_ticket.slice(index2);
      // 使用 lodash 获取最低价格的对象
      const min_day_ticket = lodash.minBy(day_ticket, (item) => parseFloat(item.displayPrice));
      const min_early_bird_ticket = lodash.minBy(early_bird_ticket, (item) => parseFloat(item.displayPrice));


      setMinPrices({
        min_day_ticket: Number(min_day_ticket.displayPrice),
        min_early_bird_ticket: Number(min_early_bird_ticket.displayPrice)
      });


    } catch (err) {
      message.error('门票价格获取失败');
    }
  }


  return (
    <div className="product-detail-wrapper">
      {baseInfo && (
        <>
          <div className="photos-wrapper">
            <Suspense fallback={<div>Loading...</div>}>
              <PhotoSwiper images={baseInfo.images} imgDimension="750x450" swiperHeight="4.5rem" />
            </Suspense>
          </div>

          <div className="module base-info">
            <div className="title">上海迪士尼乐园门票</div>
            <div className="c-warn fs-13 mb-10">仅限成人票，购买前请务必阅读购买须知</div>

            <div className="ticket-list">
              <Link to={{ pathname: '/shanghaiCultureTourism/ticket/disney_booking/1' }} className="flex-row h-between">
                <div className="ticket flex-row v-center h-between">
                  <img
                    src="https://staticfile.badazhou.com/20241023/b488ff7d1430e0dcd08211edd17ba8ca.jpeg-500x300"
                    alt="普通票"
                    className="ticket-image"
                  />
                  <div className='info'>
                    <div className='flex-row price mb-10'>
                      <div className='bold mr-10 fs-16 c-33'>普通票</div>
                      {minPrices && (
                        <div>
                          <span className='origin-price'>¥{minPrices?.min_day_ticket}</span>
                          <span className='fs-14 c-orange'>¥</span>
                          <span className='fs-21 c-orange'>{minPrices?.min_day_ticket - 28}</span>
                          <span className='fs-10 c-orange'> 起</span>
                        </div>
                      )}
                    </div>
                    <div className="booking-btn">立即预订</div>
                  </div>
                </div>
              </Link>

              <Link to={{ pathname: '/shanghaiCultureTourism/ticket/disney_booking/2' }} className="flex-row h-between">
                <div className="ticket flex-row v-center h-between">
                  <img
                    src="https://staticfile.badazhou.com/20241023/f5928a048b1cb6d69a30a7f4d725e59a.jpeg-500x300"
                    alt="早鸟票"
                    className="ticket-image"
                  />
                  <div className='info'>
                    <div className='flex-row price mb-10'>
                      <div className='bold mr-10 fs-16 c-33'>早鸟票</div>
                      {minPrices && (
                        <div>
                          <span className='origin-price'>¥{minPrices?.min_early_bird_ticket}</span>
                          <span className='fs-14 c-orange'>¥</span>
                          <span className='fs-21 c-orange'>{minPrices?.min_early_bird_ticket - 23}</span>
                          <span className='fs-10 c-orange'> 起</span>
                        </div>
                      )}
                    </div>
                    <div className="booking-btn">立即预订</div>
                  </div>
                </div>
              </Link>
            </div>

          </div>


          {/* <div
            className="module description"
            dangerouslySetInnerHTML={{ __html: baseInfo.description }}
          /> */}
          <div className="module description fs-14">
            {/* <p style={{ height: '30px' }}></p> */}
            <p className='mb-10 bold fs-16'>购票须知：</p>
            <p className='mb-10'>1. 本渠道仅支持预订全日成人票，不支持儿童票、老人票、半日票、多日票等其他票种。普通票至少提前3个工作日预订，早鸟票至少提前13天预订，门票价格以具体入园日期显示为准；</p>
            <p className='mb-10'>2. <span style={{ color: 'red', fontWeight: 'bold' }}>本渠道购票成功后不支持退票、转让、改期</span>，门票仅限订单所绑定的身份证号本人使用，凭身份证原件直接入园（不可使用电子身份证/身份证照片）；</p>
            <p className='mb-10'>3. 购票时需提供入园日期、门票数量、入园人姓名、身份证号、手机号等信息，购票成功信息将于2个工作日内以短信形式发送至客户，短信仅作为信息通知，非入园凭证；</p>
            <p className='mb-10'>4. 本渠道所售门票使用规则均以上海迪士尼度假区相关信息及通知为准；</p>
            <p>5. 如未收到出票成功短信或遇到其他订单问题，请咨询八大洲旅游官方客服：400 088 2020。</p>

            <p className='mt-20'>开放时间：<span>以上海迪士尼园区公示时间为准</span></p>
            <p className='mt-10'>乐园地址：<span>上海市浦东新区黄赵路310号</span></p>


          </div>
        </>
      )}
    </div>
  );
};

export default ProductDetail;
